document.addEventListener("DOMContentLoaded", () => {
  const checkbox = document.getElementById("CartForm-checkbox");

  // 同意時にクエリパラメータに反映する
  const urlParams = new URLSearchParams(window.location.search); 
  checkbox.addEventListener('click',function(){
    history.replaceState(null,null,this.checked ? '/cart?consent' : '/cart')
  })

  const changeSubmitBtn = (enabled) => {
    const submit_btn = document.getElementById("CartForm-submit");

    if (!!submit_btn) {
      submit_btn.disabled = !enabled;
    }
  };

  const changeAdditionalCheckoutButtons = (enabled) => {
    const additional_checkout_buttons = document.getElementById(
      "additional-checkout-buttons"
    );

    if (!!additional_checkout_buttons) {
      additional_checkout_buttons.style.visibility = enabled
        ? "visible"
        : "hidden";
    }
  };

  function handleChange(e) {
    changeSubmitBtn(e.target.checked);
    changeAdditionalCheckoutButtons(e.target.checked);
  }

  window.addEventListener("load", function () {

    //クエリから同意状態を取得する
    if (urlParams.has('consent')) {
      checkbox.checked = true;
    }
  
    checkbox.onchange = handleChange;
    checkbox.dispatchEvent(new Event("change"));
  });
});
